import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductCard } from 'src/app/modules/shared/components/shared-product/shared-product-class';
import { Product } from 'src/app/modules/shared/models/products.model';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { StoreDetailService } from 'src/app/modules/shared/services/resolver/store-detail.service';
import { SnackBarService } from 'src/app/modules/shared/services/snack-bar.service';

@Component({
  selector: 'app-whish-list',
  templateUrl: './whish-list.component.html',
  styleUrls: ['./whish-list.component.scss'],
})
export class WhishListComponent implements OnInit {
  products: ProductCard[] = [];
  storeDetail: any;
  isDesktop: boolean = false;

  scrollOption = {
    isFinish: false,
    offset: 0,
    limit: 20,
    isScroll: true,
    isFirstCall: true,
  };

  constructor(
    private panelService: PanelService,
    private router: Router,
    private storeDetailResolver: StoreDetailService,
    private location: Location,
    private snackBarService: SnackBarService,
    private deviceDetectorService: DeviceDetectorService,
  ) {
    this.isDesktop = this.deviceDetectorService.isDesktop;
  }

  ngOnInit(): void {
    this.getStoreDetail();
    this.getWishList();
  }

  onScrollProducts() {
    if (!this.scrollOption.isScroll && !this.scrollOption.isFinish) {
      this.scrollOption.isScroll = true;
      this.getWishList();
    }
  }

  getStoreDetail() {
    this.storeDetail = this.storeDetailResolver.permissionInit;
  }

  getWishList(isDeleteMode: boolean = false) {
    if (isDeleteMode) this.scrollOption.offset = 0;
    this.panelService
      .getFavoriteList({
        limit: this.scrollOption.limit,
        offset: this.scrollOption.offset,
      })
      .subscribe((products: any) => {
        this.products = this.getValidProductList(products.results);
        if (!products.next) {
          this.scrollOption.isFinish = true;
        }

        this.scrollOption.isFirstCall = false;
        this.scrollOption.isScroll = false;
        this.scrollOption.offset += 20;
      });
  }

  removeFromFavorite(productId) {
    this.panelService.deleteFromFavorite(productId).subscribe((data) => {
      this.snackBarService.showSnackBar(
        'Product removed from wishlist successfully.',
        'primary',
        2000
      );
      this.getWishList(true);
    });
  }

  private getValidProductList(rawList: Product[] | any): ProductCard[] {
    return rawList.map(
      (product) =>
        new favoriteProduct(
          product.product_detail,
          this.storeDetail,
          product.id
        )
    );
  }

  onBack() {
    this.location.back();
  }
}

class favoriteProduct extends ProductCard {
  private favorite_id: number;

  constructor(productDetail, storeDetail, favoriteId) {
    super(productDetail, storeDetail);
    this.favorite_id = favoriteId;
  }
}
